export const FILE_CHUNK_SIZE = 1024 * 1024 * 100; // 100MB chunk size
export const FILE_NAME_CHARACTERS_LIMIT = 200;
